// extracted by mini-css-extract-plugin
export var circle = "_r-2";
export var icon = "_r-a";
export var iconHighlight = "_r-0";
export var lg = "_r-8";
export var md = "_r-7";
export var outline = "_r-4";
export var sm = "_r-6";
export var square = "_r-1";
export var xl = "_r-9";
export var xs = "_r-5";
export var xxs = "_r-3";